import http from '@/lib/http.js';
import _ from 'lodash';

var store = {
	namespaced: true,
	state: {
		color: {
			primary: '#000',
			secondary: '#000'
		},
		updateTrigger: false,
		updates: [],
		loaderState: false,
		error: {
			trigger: false,
			message: 'Something went wrong'
		},
		list: {
			view: 'reader',
			hidden: []
		},
		dashboard: false
	},
	getters: {
		dashboard: function(state) {
			return state.dashboard;
		},
		isHeaderKeyHidden: function(state) {
			return headerKey => {
				if (state.list.hidden.includes(headerKey)) {
					return true;
				} else {
					return false;
				}
			};
		},
		errorTrigger: function(state) {
			return state.error.trigger;
		},
		errorMessage: function(state) {
			return state.error.message;
		},
		updates: function(state) {
			return state.updates.reverse();
		},
		updateTrigger: function(state) {
			return state.updateTrigger;
		},
		loaderState: function(state, s) {
			return state.loaderState;
		},
		listView: function(state) {
			return state.list.view;
		},
		dashboard: function(state) {
			return state.dashboard;
		}
	},
	mutations: {
		TOGGLE_LIST_HEADER_STATE: function(state, key) {
			if (state.list.hidden.includes(key)) {
				let i = state.list.hidden.indexOf(key);
				if (i > -1) {
					state.list.hidden.splice(i, 1);
				}
			} else {
				state.list.hidden.push(key);
			}
		},
		SET_LIST_VIEW_STATE: function(state, view) {
			state.list.view = view;
		},
		SET_LIST_STATE: function(state, listState) {
			state.list = listState;
		},
		SET_COLORS: function(state, colors) {
			state.color.primary = colors.primary;
			state.color.secondary = colors.secondary;
		},

		SET_UPDATE_TRIGGER: function(state) {
			state.updateTrigger = !state.updateTrigger;
		},
		SET_UPDATES: function(state, updates) {
			state.updates = updates;
		},
		SET_ERROR: function(state, message) {
			state.error.message = message || state.error.message;
			state.error.trigger = !state.error.trigger;
		},
		TOGGLE_DASHBOARD: function(state, action) {
			if (action === 'flip') {
				state.dashboard = !state.dashboard;
				return;
			}
			if (action) {
				state.dashboard = action;
			} else {
				state.dashboard = false;
			}
		},
		SET_LOADER_STATE: function(state, s) {
			state.loaderState = s;
		}
	},
	actions: {
		async setLoaderState(context, s) {
			context.commit('SET_LOADER_STATE', s);
		},
		openDashboard: function(context) {
			context.commit('TOGGLE_DASHBOARD', true);
		},
		closeDashboard: function(context) {
			context.commit('TOGGLE_DASHBOARD', false);
		},
		toggleDashboard: function(context) {
			context.commit('TOGGLE_DASHBOARD', 'flip');
		},
		setListState: function(context) {
			// context
			// 	.dispatch("cache/get", "listState", { root: true })
			// 	.then((data) => {
			// 		if (data.listState) {
			// 			context.commit("SET_LIST_STATE", data.listState);
			// 		}
			// 	});
		},
		toggleListViewState: function(context, view) {
			context.commit('SET_LIST_VIEW_STATE', view);
			// context.dispatch(
			// 	"cache/save",
			// 	{
			// 		key: "listState",
			// 		value: context.state.list,
			// 	},
			// 	{ root: true }
			// );
		},
		toggleListHeaderState: function(context, key) {
			context.commit('TOGGLE_LIST_HEADER_STATE', key);
			// context.dispatch(
			// 	"cache/save",
			// 	{
			// 		key: "listState",
			// 		value: context.state.list,
			// 	},
			// 	{ root: true }
			// );
		},
		toggleAllListHeaderState: function(context) {
			if (context.state.list.hidden.length > 0) {
				context.state.list.hidden = [];
			} else {
				let notes = context.rootGetters['note/notes'];
				let domains = [];
				for (let i = 0; i < notes.length; i++) {
					domains.push(notes[i].domain);
				}
				context.state.list.hidden = domains;
			}
		},
		setColors: function(context) {
			var el = document.querySelector('#app');
			if (el) {
				var obj = {};
				obj.primary = getComputedStyle(el)
					.getPropertyValue('--p5')
					.trim();
				obj.secondary = getComputedStyle(el)
					.getPropertyValue('--s3')
					.trim();
				context.commit('SET_COLORS', obj);
			}
		},
		sendContact: function(context, form) {
			form.userAgent = navigator.userAgent;
			var method = 'post';
			var apiPath = '/contact';
			return new Promise((resolve, reject) => {
				http
					.request(method, apiPath, form)
					.then(res => {
						resolve();
					})
					.catch(() => {
						resolve();
					});
			});
		},
		fetchUpdates: function(context) {
			http.request('get', '/updates').then(res => {
				if (res.data) {
					context.commit('SET_UPDATES', res.data);
				}
			});
		}
	}
};

export default store;
